export enum ApiKeysEnum {
  LOGIN = 'LOGIN',
  GET_USER_CLIENTS = 'GET_USER_CLIENTS',
  GET_USER_APPLICATIONS = 'GET_USER_APPLICATIONS',
  GET_USER_SITES = 'GET_USER_SITES',
  SET_USER = 'SET_USER',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  RESET_PASSWORD = 'RESET_PASSWORD',
}
